<script>
  import Animate from '@ui/pico/animate.svelte';
  import Input from '@ui/pico/input.svelte';
  import { onMount } from 'svelte';
  import { powerupForm } from '../../../../../services';

  export let form = null;
  export let show = false;
  export let active;

  $: settings = {};
  $: configure = {};

  onMount(() => {
    if (form?.powerups) {
      settings = (form?.powerups['webforma-team-email'] || {})?.settings || {};
      configure.subject = settings.subject;
      configure.recipient = settings.recipient;
      configure.from = settings.from;
      configure.body = settings.body || '';
    }

    console.log(form.powerups);
  });

  async function saveConfiguration(ev) {
    const payload = {
      settings: configure,
      fid: form._id,
      puid: 'webforma-team-email',
    };

    if (active !== undefined) {
      payload.active = active;
    }

    const resp = await powerupForm(payload);
    console.info('saveConfiguration.webforma-team-email', resp);

    ev.target.setAttribute('data-tooltip', 'Settings updated');
    setTimeout(() => {
      ev.target.removeAttribute('data-tooltip');
    }, 2000);
  }
</script>

{#if show}
  <Animate name="fadeIn">
    <li class="configure">
      <div>
        <form on:submit|preventDefault={saveConfiguration}>
          <div class="grid">
            <Input
              name="to"
              label="Recipient"
              bind:value={configure.recipient}
              placeholder="yourname@email.com"
            />
          </div>
          <div class="grid">
            <Input name="from" label="From Label" bind:value={configure.from} />
          </div>
          <div class="grid">
            <Input name="from" label="Subject" bind:value={configure.subject} />
          </div>
          <div class="grid">
            <label>
              <span>Body</span>
              <textarea bind:value={configure.body} />
            </label>
          </div>
          <div class="grid">
            <Input type="submit" class="secondary" value="Save" />
          </div>
        </form>
      </div>
    </li>
  </Animate>
{/if}

<style>
  :global(:root) {
    --sub-bg: #eee;
    --sub-highlight: #ccc;
  }
  :global([data-theme='dark']) {
    --sub-bg: rgba(0, 0, 0, 0.3);
    --sub-highlight: #222;
  }
  textarea {
    height: 400px;
  }
  /* ul {
    background: var(--sub-bg);
    border-radius: 6px;
    --color: var(--contrast);
    margin: 0 1.2rem 1.2rem;
    padding: 2rem;
  } */
  li {
    list-style-type: none;
  }
  li > div {
    padding: 1.2rem;
  }
</style>
